import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/css/style.css'

import { createApp,provide, h } from 'vue'
import { ApolloClient, createHttpLink,InMemoryCache, ApolloLink } from '@apollo/client/core'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { createApolloProvider } from '@vue/apollo-option'
import AppSyncConfig from "./appSync-config";
import { createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";

const url = AppSyncConfig.graphqlEndpoint;
const region = AppSyncConfig.region;
const auth= {
        type: AppSyncConfig.authType,
        apiKey: AppSyncConfig.apiKey,
};
const httpLink = createHttpLink({uri: url});
const link = ApolloLink.from([
    createAuthLink({ url, region, auth }),
    createSubscriptionHandshakeLink({ url, region, auth }, httpLink),
]);
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
    link,
    cache,
});

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
});

const app = createApp({
    setup () {
        provide(DefaultApolloClient, apolloClient)
      },
    render: () => h(App),
});
app.provide(/* key */ 'urlPeticion', /* value */ 'https://congresos.inspiriadental.com')

app.use(apolloProvider).use(store).use(router).mount('#app')


